

import { db } from "../../config/firebase";
import { collection, query, getDocs, orderBy } from 'firebase/firestore'




const getIsicrevfive = async () => {
    const colRef = await collection(db, 'isicrevfive');
    const q = query(
        colRef,
        orderBy('code'),
    );
    const querySnapshot = await getDocs(q);
    let dizi = [];
    querySnapshot.forEach((doc) => {
        dizi.push({ ...doc.data(), id: doc.id })
    });
    return dizi;
}

const isicrevfiveService = {
    getIsicrevfive,
}

export default isicrevfiveService